<template>
    <div class="download-block flex flex-row gap-2 justify-end mt-4">
      <button 
        @click="downloadSVG" 
        class="text-xs hover:text-Primary-600 flex items-center gap-1"
      >
        <ArrowDownTrayIcon class="w-4 h-4" /> SVG
      </button>
      | 
      <button 
        @click="downloadPNG" 
        class="text-xs hover:text-Primary-600 flex items-center gap-1"
      >
        <ArrowDownTrayIcon class="w-4 h-4" /> PNG
      </button>
    </div>

</template>

<script>
import { ArrowDownTrayIcon } from "@heroicons/vue/20/solid";
import SvgExport from "svg-export-forkmulti";
import { Canvg, presets } from 'canvg';
import Session from 'svg-text-to-path';

export default {
  name: "SvgExportButtons",
  components: {
    ArrowDownTrayIcon
  },
  props: {
    svgNode: {
      type: Object,
      required: true,
      validator: (value) => value instanceof SVGElement || value === null
    },
    filename: {
      type: String,
      default: "chart"
    }
  },
  methods: {
    downloadSVG() {
      if (!this.svgNode) {
        console.warn("SVG node is not available");
        return;
      }
      const exporter = new SvgExport({
        textToPath: Session,
      });
      exporter.downloadSvg(this.svgNode, `${this.filename}.svg`, {
        convertTextToPath: true,
        svgTextToPathSettings: {
          fonts: {
            'Quicksand': [{
              source: "/fonts/Quicksand-VariableFont_wght.ttf"
            }]
          }
        }
      });
    },
    downloadPNG() {
      if (!this.svgNode) {
        console.warn("SVG node is not available");
        return;
      }
      const exporter = new SvgExport({
        canvg: Canvg,
        presets: presets
      });
      exporter.downloadPng(this.svgNode, `${this.filename}.png`, {
        scale: 4,
      });
    }
  }
};
</script>

